import useAuth from "../auth/useAuth.js";
import Hijack from "../support/Hijack.js";
import {HexPagePreview, HexPagePreviewGrid} from "./PagePreviewHex.js";

import React, { useState, useEffect, useRef } from 'react';
import { Link as RouterLink} from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';
import Edit from '@material-ui/icons/Edit';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

const previewStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        position: 'relative',
        flexDirection: 'row',
        padding: 15,
        marginBottom: 15,
        borderColor: 'var(--darkerGrey)',
        height: "100%",
        [theme.breakpoints.down("md")]: {
            display: 'block'
        }
    },
    title: {
        fontSize: "1.1em !important"
    },
    content: {
        flex: '1 1 auto',
        paddingLeft: 15,
        display: 'flex',
        width: '100%',
        flexDirection: 'column'
    },
    edit: {

    },
    image: {
        flex: '0 0 200px',
        [theme.breakpoints.down("md")]: {
            textAlign: 'center'
        }
    },
    chip: {
        background: 'transparent',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        fontSize: '1rem',
        color: '#999',
        fontFamily: 'var(--secondaryText)',
        whiteSpace: "wrap",
        "& .MuiChip-label": {
            whiteSpace: "wrap",
            textAlign: "right"
        }
    },
    chipWarn: {
        background: 'rgb(237, 108, 2)'
    },
    videoLink: {
        color: 'var(--red)',
        cursor: 'pointer',
        display: "flex",
        alignItems: "flex-end",
        "&:hover": {
            color: "var(--black)"
        }
    },
    description: {
        flexGrow: 1,
        "& p": {
            marginBlockStart: "0.5em",
            marginBlockEnd: "0.5em"
        },
        "& img": {
            maxWidth: "100%",
            height: "auto"
        }
    },
    showcase: {
        //"& h3": {
        //    fontFamily: "var(--primaryText)"
        //},
        "& $description": {
            display: 'flex',
            alignItems: 'flex-end'
        },
        "& $image": {
            flexBasis: '120px'
        },
        "& $image img": {
            maxWidth: '120px',
            [theme.breakpoints.down("md")]: {
                maxWidth: '200px'
            }
        },
        "& $edit": {
            position: 'absolute',
            left: '0',
            bottom: '0',
            backgroundColor: 'rgba(255,255,255,0.6)'
        },
    },
    renaiShowcase: {
        "& $description": {
            display: 'flex',
            alignItems: 'flex-end'
        },
        "& $image": {
            flexBasis: '120px'
        },
        "& $image img": {
            maxWidth: '120px',
            [theme.breakpoints.down("md")]: {
                maxWidth: '200px'
            }
        },
        "& $edit": {
            position: 'absolute',
            left: '0',
            bottom: '0',
            backgroundColor: 'rgba(255,255,255,0.6)'
        },
    }
    
}));
const PagePreview = (props) => {
    const { area, page, tags, selectedOptions, uneditable, collection } = props;
    const classes = previewStyles();
    const auth = useAuth();
    const [canContribute, setCanContribute] = useState(false);
    const [canApprove, setCanApprove] = useState(false);
    const [needsApproval, setNeedsApproval] = useState(false);
    const [previewTags, setPreviewTags] = useState([]);
    const [videoOpen, setVideoOpen] = useState(false);
    const contentRef = useRef(null);
    const videoRef = useRef(null);

    const getPreviewTags = () => {
        var out = [];
        if (!selectedOptions) {
            for (var i = 0; i < tags.length; i++) {
                if (tags[i].showInPreview) {
                    for (var j = 0; j < tags[i].options.length; j++) {
                        if (page.options && page.options.indexOf(tags[i].options[j].id) != -1) {
                            out.push(tags[i].options[j].name);
                        }
                    }
                }
            }
        } else {
            out = selectedOptions;
        }
        setPreviewTags(out);
    };
    useEffect(getPreviewTags, [page, tags]);

    useEffect(() => {
        if (page) {
            if (page.area == "article" || page.area == "showcase" || page.area == "collection" || page.area == "page" || page.area == "unlisted" || page.area == "renaissance_showcase" || page.area == "renaissance_events") {
                setCanContribute(auth.user.id && auth.user?.roles && auth.user.roles.indexOf(page.area + ".contributor") !== -1);
                setCanApprove(auth.user.id && auth.user?.roles && auth.user.roles.indexOf(page.area + ".approver") !== -1);
            } else if (page.area != "search" && auth.user.id && auth.user?.roles && auth.user.roles.indexOf("admin") !== -1) {
                setCanContribute(true);
                setCanApprove(true);
            }
        }
    }, [auth, page]);

    function buildClassName(s) {
        const classList = [s];
        if (page.area == "showcase")
            classList.push(classes.showcase);
        if (page.area == "renaissance_showcase")
            classList.push(classes.renaiShowcase);
        return classList.join(" ");
    }
    return (
        <Paper elevation={1} variant="outlined" square={true} className={buildClassName(classes.root)}>
            {(page.area != "article" && page?.thumbnail) ?
                <Box className={classes.image}>
                    <RouterLink to={"/" + page.area + "/" + (page.url || page.id)}><img src={page.thumbnail} alt={page.title} /></RouterLink>
                </Box>
            : null}
            <Box className={classes.content}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography component="h3" variant="h3" className={classes.title}>
                        <RouterLink to={{
                            pathname: "/" + page.area + "/" + (page.url || page.family),
                            state: { collection }
                        }}>{page.title}</RouterLink>
                        {page.state == "workflow" ? (<Chip label={"In Workflow"} variant="outlined" size="small" />) : ""}
                        {page.redirect ? (<Chip label={"Redirect"} className={classes.chipWarn} size="small" />) : ""}
                    </Typography>
                    {(canContribute && uneditable !== true) ? <Tooltip title="Make changes to the page"><Button color="primary" className={classes.edit} component={RouterLink} to={"/" + page.area + "/" + page.id + "/edit"}>
                        <Edit /> Edit</Button></Tooltip> : ""}
                </Box>
                {((page.area == "showcase" || page.area == "renaissance_showcase") && page?.video) ?
                    <React.Fragment>
                        <Box className={classes.videoLink} onClick={() => { setVideoOpen(true); }}><PlayCircleOutlineIcon />&nbsp;&nbsp;Preview video</Box>
                        <Dialog open={videoOpen} fullWidth={true}  onClose={() => { setVideoOpen(false); }} aria-labelledby={"form-dialog-video-" + page.id}>
                            <DialogTitle id={"form-dialog-video-" + page.id}>{page.title}</DialogTitle>
                            <DialogContent><Hijack><div ref={videoRef} dangerouslySetInnerHTML={{ __html: page?.video ?? "" }}></div></Hijack></DialogContent>
                            <DialogActions>
                                <Button onClick={() => { setVideoOpen(false); }} color="primary">Ok</Button>
                            </DialogActions>
                        </Dialog>
                    </React.Fragment>
                    : null}
                <Box className={classes.description}>
                    <Hijack>
                        <Box ref={contentRef} dangerouslySetInnerHTML={{ __html: page?.description ?? "" }}></Box>
                    </Hijack>
                </Box>
                <Box display="flex" justifyContent="flex-end" flexWrap="wrap">
                {
                    !area || (area && area.features.indexOf("noChipsInSearchPreview") === -1) ?
                        previewTags.map((option) => {
                            return (<Chip key={option} label={option} className={classes.chip} />);
                        })
                        : null
                }
                </Box>
            </Box>
        </Paper>
    );
};

export default PagePreview;
